export const BorrowerRegistrationStep = {
	NotStarted: -1,
	AbsherVerification: 0,
	PersonalInformation: 1,
	BusinessInformation: 2,
	DocumentVerification: 3,
	Declaration: 4,
};
